/* eslint-disable @angular-eslint/no-output-on-prefix */
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BreakpointDirective } from 'src/app/directives/breakpoint.directive';
import { SearchComponent } from 'src/app/libs/search/search.component';
import { TbtkSideNavService } from 'src/app/libs/sidenav/sidenav.service';

/**
 * A component that is used to display the header of the application.
 *
 * ### Usage Example
 * Add the below code to your code stack and give initializer parameters.
 *
 * ```ts
 * @Input() isHidden = true;
 * @Output() onChange - Line is creating an output property called `onChange` of type `EventEmitter<string>`.
 * @Output() onFocus - Line is creating an output property called `onFocus` of type `EventEmitter<string>`.
 * @Output() onBlur - Line is creating an output property called `onBlur` of type `EventEmitter<string>`.
 * @Output() onEnter - Line is creating an output property called `onEnter` of type `EventEmitter<string>`.
 * @Output() onClick - Line is creating an output property called `onClick` of type `EventEmitter<string>`.
 * ```
 *
 * <sub>app.component.html</sub>
 *
 * ```html
 * <tbtk-header (onChange)="test($event)" (onBlur)="test($event)" (onFocus)="test($event)" [isHidden]="searchResultIsHidden">
 *   <div customSearch>
 *     <div class="form-group">
 *       <label for="search">Search</label>
 *       <input type="text" id="search" class="form-control" placeholder="Search" />
 *     </div>
 *   </div>
 *   <ng-container right>
 *     <button class="btn btn-primary btn-sm ti-plus" [forMenu]="'header-new'">{{ 'NEW' | translate }}</button>
 *     <button class="btn btn-neutral btn-md btn-ghost ti-lg ti-settings"></button>
 *   </ng-container>
 *   <tbtk-profile [firstName]="'Serkan'" [lastName]="'Konakcı'" email="serkan.konakci@tubitak.gov.tr">
 *     <tbtk-menu-item icon="/assets/images/icons/user.svg" class="save-icon" (click)="action('Profil Ayarları Clicked')">Profil Ayarları</tbtk-menu-item>
 *     <tbtk-menu-item icon="/assets/images/icons/question-circle.svg" class="save-icon" (click)="action('Yardım')">Yardım</tbtk-menu-item>
 *     <hr />
 *     <tbtk-menu-item icon="/assets/images/icons/logout.svg" class="save-icon" (click)="action('Çıkış')">Çıkış Yap</tbtk-menu-item>
 *   </tbtk-profile>
 * </tbtk-header>
 *
 * <tbtk-menu id="header-new" [arrow]="true">
 *   <tbtk-menu-item icon-class="ti-document-filled ti-lg">Dosya Yükle</tbtk-menu-item>
 *   <tbtk-menu-item icon-class="ti-folder ti-lg">Klasör Yükle</tbtk-menu-item>
 *   <tbtk-menu-item icon-class="ti-text ti-lg">Yeni Metin Dokümanı</tbtk-menu-item>
 *   <tbtk-menu-item icon-class="ti-chart ti-lg">Yeni Sunum Dosyası</tbtk-menu-item>
 *   <tbtk-menu-item icon-class="ti-chart-vertical ti-lg">Yeni Hesap Cetveli</tbtk-menu-item>
 *   <tbtk-menu-item icon-class="ti-suitcase ti-lg">Kurumsal Şablondan Seç</tbtk-menu-item>
 * </tbtk-menu>
 * ```
 *
 * Put filter template under the customSearch attribute
 */
@Component({
  selector: 'tbtk-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: true,
  imports: [BreakpointDirective, CommonModule, SearchComponent],
})
export class TbtkHeaderComponent {
  isMobile = false;
  searchOpen = false;
  @Input() isHidden = true;
  @Input() value = '';
  @Input() modalId = '';
  @Output() onChange = new EventEmitter<string>();
  @Output() onFocus = new EventEmitter<string>();
  @Output() onBlur = new EventEmitter<string>();
  @Output() onEnter = new EventEmitter<string>();
  @Output() onClick = new EventEmitter<string>();

  constructor(private sideNavService: TbtkSideNavService) {}

  handleButtonOpenSearch(): void {
    this.searchOpen = !this.searchOpen;
  }

  openCloseSideNav(): void {
    this.sideNavService.isClose = !this.sideNavService.isClose;
  }
}
